import {
    isFolderOfTreeType,
    SHARED_FOLDERS_TREE_TYPE,
    ARCHIVE_FOLDERS_TREE_TYPE,
} from 'owa-folders';

/**
 * Helper to determine if we should update the folder unread/total count
 * @param folderId
 */
export default function shouldUpdateFolderCount(folderId: string) {
    // For archive mailbox and shared folders hierarchy notifcations are disabled, so we should update the count
    return (
        isFolderOfTreeType(folderId, ARCHIVE_FOLDERS_TREE_TYPE) ||
        isFolderOfTreeType(folderId, SHARED_FOLDERS_TREE_TYPE)
    );
}
